angular.module('ikeweb.spike.gallery').controller('GalleryItemController', ['$scope', 'spikeCaptureService', '$location', 'promiseFactory',

    function($scope, captureService, $location, promiseFactory) {

        function enableEditing() {
            $scope.isReadOnly = false;
        }

        function disableEditing() {
            $scope.isReadOnly = true;
        }

        function setCaptureName() {
            $scope.captureName = $scope.capture.getName();
        }

        function rename() {
            disableEditing();
            if ($scope.captureName !== $scope.capture.getName()) {
                return captureService.renameCapture($scope.capture, $scope.captureName)
                    .then(setCaptureName);
            }
            return promiseFactory.resolvedPromise();
        }

        function goToReport() {
            this.blurInput();
            rename().then(function() {
                $location.path('photoMeasure/' + $scope.capture.id + '/report');
            });
        }

        setCaptureName();

        this.rename = rename;
        this.goToReport = goToReport;
        this.enableEditing = enableEditing;
        this.disableEditing = disableEditing;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/gallery/item/gallery.item.controller.js
// module id = 526
// module chunks = 0